export const categories = [
    {
        id: 1,
        label: "Tire"
    },
    {
        id: 2,
        label: "Wheel"
    }
]